/** Cliente del servidor propio (/api). La sesión va en una cookie HttpOnly; aquí nunca se ve. */

export class ApiError extends Error { constructor(public status: number, message: string) { super(message); } }

export interface Me { email: string; displayName: string; workbooks: Array<{ kind: 'main'; fileId: string; name: string }> }
export interface ClientConfig { googleClientId: string; projectNumber: string; pickerApiKey: string }

async function call<T>(path: string, init: RequestInit = {}): Promise<T> {
  const mutating = init.method && init.method !== 'GET';
  const r = await fetch(`/api${path}`, { credentials: 'same-origin', ...init,
    headers: { ...(mutating ? { 'x-sut': '1', 'content-type': 'application/json' } : {}), ...(init.headers ?? {}) } });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new ApiError(r.status, (j as { error?: string }).error ?? `Error ${r.status}`);
  return j as T;
}

let token: { accessToken: string; expiresAt: number } | null = null;

export const api = {
  me: () => call<Me>('/me'),
  config: () => call<ClientConfig>('/config'),
  /** Token de Google de corta duración para leer y escribir el libro directamente; se reutiliza hasta 2 minutos antes de caducar. */
  async accessToken(): Promise<string> {
    if (token && token.expiresAt - Date.now() > 120000) return token.accessToken;
    let t;
    try { t = await call<{ accessToken: string; expiresAt: string }>('/auth/token'); }
    catch (err) {
      // Google ya no deja usar el permiso (lo retiraste, cambió la contraseña o caducó): que la app lo diga y ofrezca darlo otra vez
      if (err instanceof ApiError && err.status === 401) dispatchEvent(new CustomEvent('sut-reauth', { detail: err.message }));
      throw err;
    }
    token = { accessToken: t.accessToken, expiresAt: Date.parse(t.expiresAt) };
    return t.accessToken;
  },
  setWorkbook: (fileId: string) => call<{ fileId: string; name: string }>('/workbook', { method: 'PUT', body: JSON.stringify({ fileId }) }),
  pushKey: () => call<{ publicKey: string }>('/push/key'),
  savePush: (sub: PushSubscriptionJSON, minutes: number, timeZone: string) =>
    call<{ ok: true }>('/push/subscription', { method: 'PUT', body: JSON.stringify({ ...sub, minutes, timeZone }) }),
  deletePush: (endpoint: string) => call<{ ok: true }>('/push/subscription', { method: 'DELETE', body: JSON.stringify({ endpoint }) }),
  testPush: () => call<{ sent: number; devices: number }>('/push/test', { method: 'POST', body: '{}' }),
  logout: () => call<{ ok: true }>('/auth/logout', { method: 'POST', body: '{}' }),
};
